import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import React from 'react';

export default function OnboardingError({ errorMessage }) {
  const handleRedirect = () => {
    window.close();
  };
  return (
    <Stack sx={{ justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
      <Card sx={{ width: '60vh' }}>
        <CardContent>
          <Typography variant="h6" component="div">
            EmaraTax ASP Linking Failed
          </Typography>
          <Typography variant="body2" sx={{ my: 2 }}>
            We were unable to complete the link with EmaraTax. Please re-initiate the linking request again from
            EmaraTax.
          </Typography>
          <Typography variant="body1" color="error">
            <strong>Error Details:</strong> {errorMessage}
          </Typography>
          <Button variant="contained" onClick={handleRedirect} sx={{ mb: 2, float: 'right' }}>
            Redirect To EmaraTax now
          </Button>
        </CardContent>
      </Card>
    </Stack>
  );
}
